var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _path28, _path29, _path30, _path31, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 232,
    viewBox: "0 0 313 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.9338 48.1818C100.1 17.5957 155.487 -13.4975 185.706 17.5613C194.996 28.3427 195.554 44.0635 202.994 56.0813C228.236 94.0277 267.261 61.9138 292.326 78.6469C313.29 103.937 286.244 141.988 259.84 162.112C134.32 271.524 -103.131 196.678 72.9338 48.1818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.1 201.55C126.1 193.95 124.1 176.11 124.1 165.55C124.1 152.35 128.3 136.15 130.7 136.75C132.62 137.23 132.3 149.75 131.9 155.95C137.5 147.95 149.18 132.31 151.1 133.75C153.5 135.55 142.7 151.151 142.7 155.95C146.9 149.15 155.66 135.79 157.1 136.75C158.54 137.71 151.7 152.75 148.1 160.15C150.9 153.15 156.98 139.63 158.9 141.55C160.82 143.47 155.3 154.75 152.3 160.15C154.9 156.75 160.46 150.31 161.9 151.75C163.7 153.55 151.7 167.35 149.9 173.35C148.46 178.15 149.3 190.95 149.9 196.75M134.9 158.35C135.7 159.55 137.3 163.39 137.3 169.15M139.1 160.15C141.5 161.95 146.9 165.67 149.3 166.15M142.7 166.15C144.1 167.75 146.9 171.91 146.9 175.75M130.1 202.15L134.9 229.815M134.9 229.815C132.723 229.892 131.044 229.836 130.1 229.75L124.7 202.15C128.808 202.003 132.647 201.591 136.1 201.044M134.9 229.815C137.08 229.738 139.759 229.527 142.7 229.078M136.1 201.044L142.7 229.078M136.1 201.044C140.98 200.271 145.089 199.228 148.1 198.283M142.7 229.078C143.675 228.929 144.677 228.754 145.7 228.55C147.397 228.211 148.971 227.798 150.408 227.35M142.7 200.35L150.408 227.35M150.408 227.35C152.84 226.591 154.877 225.73 156.443 224.95M148.1 198.283C149.931 197.708 151.355 197.17 152.3 196.75L159.5 223.15C158.916 223.588 157.877 224.235 156.443 224.95M148.1 198.283L156.443 224.95",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.1 152.35C253.3 144.75 247.1 129.55 244.7 129.55C242.3 129.55 243.3 136.35 244.1 139.75C236.3 129.55 233.9 128.95 233.3 129.55C232.82 130.03 233.9 134.95 234.5 137.35",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.5 158.349L235.1 153.549C233.3 151.149 231.26 146.949 237.5 149.349",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.794 115.319L193.797 114.975C194.355 114.965 194.831 114.571 194.948 114.026L199.312 93.5692C199.549 92.4573 201.056 92.268 201.561 93.2867L211.415 113.167C211.636 113.613 212.11 113.877 212.607 113.828L239.187 111.236C240.351 111.123 240.973 112.572 240.089 113.338L221.436 129.488C221.047 129.825 220.916 130.371 221.11 130.847L230.153 153.115C230.596 154.205 229.369 155.214 228.385 154.571L207.614 140.996C207.182 140.713 206.617 140.739 206.212 141.06L189.643 154.191C188.752 154.898 187.469 154.083 187.729 152.976L192.708 131.807C192.817 131.346 192.644 130.865 192.268 130.578L175.089 117.473C174.185 116.783 174.657 115.341 175.794 115.319Z",
    fill: "#FFE200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.5 119.35L193.7 116.35L196.1 91.1499L210.5 113.35L241.1 106.75L221.3 128.35L235.1 153.55L208.7 140.35L190.7 158.35L193.7 132.55L171.5 119.35Z",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 163.75C28.7 160.35 31.58 152.35 33.5 147.55C35.9 141.55 41.3 131.95 45.5 134.35",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 151.15C39.9 149.35 41.18 144.55 43.1 139.75C45.5 133.75 47.9 130.75 50.3 131.95",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0996 152.949C46.2996 150.549 47.0596 144.429 48.4996 139.149C50.2996 132.549 52.6996 130.149 55.0996 131.949",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.699 176.95C61.899 170.55 68.779 157.15 70.699 154.75C73.099 151.75 71.299 149.35 68.299 151.15C65.899 152.59 60.899 157.75 58.699 160.15C59.299 150.95 59.899 132.55 57.499 132.55C54.499 132.55 52.099 148.15 52.699 152.35",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5002 169.037C23.2078 166.371 24.6914 164.36 25.7002 163.15C27.5002 164.35 33.0202 167.59 40.7002 170.95C48.3802 174.31 55.5002 176.75 58.1002 177.55L57.4891 184.15M21.5002 169.037C18.1295 174.299 13.8862 182.111 10.7002 191.35C19.7002 197.35 41.1802 209.47 55.1002 209.95L57.4891 184.15M21.5002 169.037C23.9002 170.675 30.5002 174.67 37.7002 177.55C46.7002 181.15 51.478 182.95 57.4891 184.15",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1971 72.2158L88.9344 39.467C89.1379 38.8462 89.8006 38.5023 90.4254 38.6932L109.642 44.5649C110.318 44.7714 110.67 45.5139 110.402 46.1676L96.8782 79.1647C96.4914 80.1085 95.1781 80.17 94.7048 79.2664L89.8472 69.9927C89.5438 69.4135 88.8324 69.1838 88.2475 69.4762L79.874 73.663C78.9204 74.1398 77.8649 73.229 78.1971 72.2158Z",
    fill: "#E5B422"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M117.523 78.677L121.233 47.0263C121.32 46.2835 122.057 45.7993 122.782 45.9828C128.964 47.5473 138.972 48.3822 144.561 48.6755C145.311 48.7148 145.844 49.4201 145.676 50.1522L138.118 82.9547C137.9 83.9008 136.707 84.2099 136.057 83.4888L128.129 74.6951C127.716 74.2363 127.021 74.1665 126.525 74.5338L119.428 79.7816C118.583 80.4063 117.4 79.7206 117.523 78.677Z",
    fill: "#FFE200"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9004 37.1499L74.9004 73.7499L86.9004 67.7499L93.5004 80.3499L108.5 43.7499",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.3 45.5498L115.1 79.7498L125.3 72.5498L135.5 83.3498L143.9 48.5498",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.595 82.1871L150.951 48.2264C150.894 47.4835 151.52 46.8685 152.263 46.9245C161.18 47.5969 170.372 46.6967 175.162 45.9658C175.948 45.8458 176.632 46.4779 176.522 47.2661C175.742 52.8672 172.971 70.7193 171.213 81.9465C171.045 83.0159 169.66 83.3267 169.043 82.4374L163.382 74.2787C162.898 73.5818 161.864 73.5929 161.395 74.2999L155.792 82.7568C155.161 83.7083 153.684 83.3251 153.595 82.1871Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1 48.5497L158.3 87.5497L166.1 73.7497L176.3 85.1497C177.1 72.7497 178.7 47.3497 178.7 44.9497",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M256.322 48.4599L236.638 17.2751C236.253 16.6647 235.42 16.5302 234.862 16.9883L217.821 30.9847C217.304 31.4097 217.234 32.176 217.667 32.6872L240.181 59.2912C240.854 60.0864 242.151 59.7052 242.287 58.6723L243.528 49.2193C243.619 48.5285 244.277 48.06 244.96 48.2001L255.066 50.2759C256.102 50.4887 256.887 49.3544 256.322 48.4599Z",
    fill: "#E53826"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.072 75.7151C194.032 69.3285 189.988 53.2385 187.752 44.0489C187.617 43.4937 187.893 42.9227 188.411 42.6811L208.573 33.2721C209.43 32.8724 210.492 33.5705 210.558 34.5136C211.057 41.7346 214.961 61.1407 217.479 72.8497C217.698 73.8717 216.598 74.6673 215.696 74.1402L202.7 66.5531C202.052 66.1749 201.22 66.4771 200.966 67.1828L197.898 75.703C197.548 76.6747 196.387 76.699 196.072 75.7151Z",
    fill: "#78BEE1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M200.3 76.1495C198.86 73.7495 192.9 52.7495 190.1 42.5495L212.9 31.7495C212.42 36.0695 218.3 61.1495 221.3 73.1495L204.5 64.1495L200.3 76.1495Z",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M239.3 15.5498L257.9 52.1498L244.1 47.9498L241.1 61.1498L218.9 29.3498",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1759 53.1557L55.4481 25.9445C55.7091 25.4094 56.323 25.1465 56.8904 25.327L77.9278 32.019C78.6617 32.2524 78.9888 33.107 78.5984 33.7709L59.537 66.18C59.0339 67.0354 57.7689 66.9452 57.3924 66.027L51.496 51.649C51.215 50.9637 50.3864 50.6941 49.7559 51.0828L43.8842 54.7032C42.8611 55.3341 41.6489 54.236 42.1759 53.1557Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3 23.9497L36.5 52.1497L47.9 47.3497L52.7 65.3497L78.5 34.1497",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 15.5499C58.3 25.7499 95.78 46.6299 143.3 48.5499C190.82 50.4699 230.3 23.7499 244.1 10.1499",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M113.821 129.055L86.0572 102.803C84.8834 101.693 82.9703 102.037 82.2558 103.486L70.3623 127.604C69.6005 129.149 70.6659 130.97 72.3858 131.062L112.044 133.196C114.274 133.316 115.445 130.59 113.821 129.055Z",
    fill: "#78BEE1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.285 126.389L81.5004 99.5498L70.1004 131.35L116.638 128.546C117.753 128.479 118.179 127.059 117.285 126.389Z",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9004 145.749C65.5004 130.349 76.8204 99.3092 77.3004 98.3492C77.9004 97.1492 82.1004 98.3492 80.9004 100.749C79.9404 102.669 66.5004 140.349 59.9004 158.95",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.1004,
    cy: 179.35,
    r: 1.2,
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M124.7 110.35C131.5 110.55 148.94 114.55 164.3 128.95",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M143.301 104.95C146.901 106.35 155.901 111.07 163.101 118.75",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M240.501 185.95C236.701 179.35 228.621 164.95 226.701 160.15C224.301 154.15 224.301 151.75 224.901 151.15C225.501 150.55 226.7 148.75 230.3 153.55C233.9 158.35 236.9 166.15 241.7 162.55C246.5 158.95 241.7 152.35 238.7 149.35C235.7 146.35 228.501 140.95 226.701 139.15C224.901 137.35 224.3 134.35 231.5 136.75C238.7 139.15 250.7 144.549 257.3 153.55C262.58 160.75 265.5 167.35 266.3 169.75",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M240.842 193.75L238.1 186.55C247.22 183.67 261.1 174.15 266.9 169.75L281.3 197.95C267.38 206.59 253.1 210.75 247.7 211.75L240.842 193.75ZM240.842 193.75C243.928 192.55 251.3 189.43 256.1 186.55C260.9 183.67 267.3 179.35 269.9 177.55",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.7,
    cy: 175.75,
    r: 1.2,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.f719904bc98f7ea422dbc22894b5b372.svg";
export { ForwardRef as ReactComponent };